import MockUpUtil from 'edge/api/gw-portals-util-js/MockUpUtil';
import flowConfigUtil from 'edge/quoteandbind/common/util/FlowConfigUtil';

var mockUpUtil = new MockUpUtil();

export default (function (AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelContext, ActionMessageUtil, EventHub, QuoteJumpToStepService) {
    var translateFn = TranslateService.instant;
    var wrappedLoadSave = flowConfigUtil.wrappedLoadSave(ViewModelService, ViewModelContext);

    var ACTION_MSG = {
        updateSubmission: {
            error: {
                title: 'quoteandbind.common.config.FlowConfig.Unable to save submission',
                message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.'
            },
            progress: {
                message: 'quoteandbind.common.config.FlowConfig.Saving quote...'
            }
        },
        updateDraftSubmission: {
            error: {
                title: 'quoteandbind.common.config.FlowConfig.Unable to save submission',
                message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.'
            },
            progress: {
                message: 'quoteandbind.common.config.FlowConfig.Saving quote...'
            }
        },
        updateQuotedSubmissionWithLOBData: {
            error: {
                title: 'quoteandbind.pa.config.FlowConfig.Unable to update quoted submission',
                message: 'quoteandbind.pa.config.FlowConfig.An error occurred while attempting to update quote submission.'
            },
            progress: {
                message: 'quoteandbind.pa.config.FlowConfig.Saving quote details...'
            }
        },
        bindSubmission: {
            error: {
                title: 'quoteandbind.common.config.FlowConfig.Unable to purchase quote',
                message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to bind your quote submission'
            },
            progress: {
                message: 'quoteandbind.common.config.FlowConfig.Processing Payment...'
            }
        }
    };

    var ACTIONS = {
        updateSubmission: function updateSubmission(_ref) {
            var submission = _ref.value;

            return wrappedLoadSave(LoadSaveService.updateDraftSubmissionAndPrimaryLocation, submission);
        },
        updateDraftSubmission: function updateDraftSubmission(_ref2) {
            var submission = _ref2.value;

            return wrappedLoadSave(LoadSaveService.updateDraftSubmission, submission);
        },
        updateQuotedSubmissionWithLOBData: function updateQuotedSubmissionWithLOBData(_ref3) {
            var submission = _ref3.value;

            return wrappedLoadSave(LoadSaveService.saveQuotedSubmissionWithLOBData, submission);
        },
        saveAndQuoteSubmission: function saveAndQuoteSubmission(_ref4) {
            var submission = _ref4.value;

            return wrappedLoadSave(LoadSaveService.saveAndQuoteSubmission, submission);
        },
        bindSubmission: function bindSubmission(_ref5) {
            var submission = _ref5.value;

            return wrappedLoadSave(LoadSaveService.bindSubmission, submission);
        }
    };

    return {
        coverables: function coverables(step, junction) {
            step('puwVehicleDetails', true).onNext.doAction(ACTIONS.updateSubmission, ActionMessageUtil.quoteFailMessage).thenGoTo('puwCoverablesComplete', 'error').skipOnResumeIf(function (_ref6) {
                var submission = _ref6.value;

                var vehicle = submission.lobData.puw_PSA.coverables.vehicles[0];
                var vinMockData = mockUpUtil.getMockData('lobData.puw_PSA.coverables.vehicles.vehicle.vin');

                return vehicle && submission.baseData.periodStatus === 'Quoted' && vehicle.vin !== vinMockData;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Vehicles');
            });

            junction('puwCoverablesComplete');
        },
        quote: function quote(step, junction) {
            junction('checkIfQuoteCallNeeded', true).onNext.branch(function (_ref7) {
                var submission = _ref7.value;

                QuoteJumpToStepService.addQuoteSnapshot(submission);
                return QuoteJumpToStepService.shouldSkipQuote(submission) ? 'puwQuoteDetails' : 'generateQuote';
            });

            junction('generateQuote').onNext.doAction(ACTIONS.saveAndQuoteSubmission, ActionMessageUtil.quoteFailMessage).thenGoTo('puwQuoteDetails', 'error');

            step('puwQuoteDetails').onNext.goTo('offeringSelected', 'error').skipOnResumeIf(function (model) {
                return model.bindData.policyNumber && model.bindData.policyNumber.value;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Quote');
            });

            junction('offeringSelected');
        },
        bindAndPay: function bindAndPay(step, junction) {
            step('puwSummary', true).onNext.doAction(ACTIONS.bindSubmission, ACTION_MSG.bindSubmission).thenGoTo('puwConfirmation', 'error').skipOnResumeIf(function (model) {
                return model.bindData.policyNumber && model.bindData.policyNumber.value;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Policy Information');
            });

            step('puwConfirmation').onNext.goTo('returnHome').label(function () {
                return translateFn('quoteandbind.wizard.step.Confirmation');
            });

            junction('returnHome');
        }
    };
});